import { useTranslation } from 'react-i18next';

import type { ChallengeTypeApi } from '../../types/api/challenges';
import type { ChallengeLeaderEntryRedux } from '../../types/models/challenges';

import { useImageExists } from '../../shared/hooks/useImageExists';
import {
  formatName,
  getChallengeTypeUnit,
  getFormattedValue,
  getInitial,
} from '../../shared/util/challenges';

interface BoardListRowProps {
  user: ChallengeLeaderEntryRedux;
  userPlace: number;
  challengeType: ChallengeTypeApi | string;
  leaderBoard?: boolean;
}

function BoardListRow({ user, userPlace, challengeType, leaderBoard }: BoardListRowProps) {
  const { t } = useTranslation();
  const imageExists = useImageExists(user?.image);

  return (
    <li
      className={`boardList-row ${leaderBoard ? 'boardList-row-leader' : ''} ${
        leaderBoard && userPlace < 14 ? 'boardList-row-leader' : ''
      } ${!leaderBoard && userPlace === user.place ? 'boardList-row-user' : ''}`}
    >
      <div className="boardList-number">
        {user.place}
        <span className="visuallyHidden">{t('challenge.leaderboard.rank.label')}</span>
      </div>
      <div className={`boardList-user ${userPlace === user.place ? 'boardList-user-active' : ''}`}>
        <div className="boardList-user-1">
          <div
            className="boardList-avatar fs-exclude"
            style={imageExists ? { backgroundImage: `url(${user?.image})` } : {}}
          >
            <div className="boardList-initial" style={imageExists ? { display: 'none' } : {}}>
              {getInitial(user?.name || '')}
            </div>
          </div>
          <div className="boardList-name">{formatName(user.name)}</div>
        </div>
        <div className="boardList-user-2">
          <div className="boardList-progress">{getFormattedValue(user.score, challengeType)}</div>
          <div className="boardList-progress-unit">
            {getChallengeTypeUnit(challengeType, user.score)}
          </div>
        </div>
      </div>
    </li>
  );
}

export default BoardListRow;
